import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Modal, Row, Col, Spinner} from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import Select from "react-select";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { sports } from '../../../../components/Util/enum';
import { useMemberships } from '../../../../../hooks/useMemberships';
import { useProfile } from '../../../../../hooks/useProfile';

export const MaestriTable = () => {
	const navigate = useNavigate();

	const [modalCentered, setModalCentered] = useState(false);
	const [data_json, setDataJson] = useState(null);
	const [sportFilter, setSportFilter] = useState('');

	// Chip dello sport: le discipline presenti nella lista (un maestro puo' averne piu' d'una).
	const sportOptions = useMemo(
		() =>
			data_json
				? [...new Set(data_json.flatMap((row) => (row.sport ? row.sport.split(',').map((s) => s.trim()).filter(Boolean) : [])))].sort()
				: [],
		[data_json],
	);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) => !sportFilter || (row.sport ? row.sport.split(',').map((s) => s.trim()) : []).includes(sportFilter),
			),
		[data_json, sportFilter],
	);
	const { getConfirmedMembers, fetchMemberships, invalidateCache } = useMemberships({ autoFetch: true });
	const { getPendingRequests } = useMemberships({ autoFetch: true });
	const { profile } = useProfile({ autoFetch: true });

	const [showedSports, setShowedSports] = useState([]);

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
	const [confirmText, setConfirmText] = useState('');

	const [memberOptions, setMemberOptions] = useState(null);
	const [memberOptionsFull, setMemberOptionsFull] = useState(null);

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

    const [loadingShowed, setLoadingShowed] = useState(false);
    
	const [selectedMembers, setSelectedMembers] = useState([]);
	const handleSelectChangeMembers = (selectedOptions) => {
		setSelectedMembers(selectedOptions ? selectedOptions.map(o => o.value) : []);
	};

	const [selectedSport, setSelectedSport] = useState('');
	const handleSelectChangeSport = (selectedOptions) => {
		setSelectedSport(selectedOptions.value);
	};

	const data_column = [

		{
			Header: 'Nome e cognome',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
						alt={row.original.name}
						style={{
						width: '40px',
						height: '40px',
						borderRadius: '50%',
						marginRight: '10px'
						}}
					/>
				  	{row.original.name}
				</div>
			)
		},
		{
			Header: 'Email',
			Footer: 'Email',
			accessor: 'email',
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sport',
			disableGlobalFilter: true,
		},
		{
            Header: 'Stato',
            Footer: 'Stato',
            id: 'status',
            accessor: row => row.status?.label,
            disableGlobalFilter: true,
            Cell: ({ row }) => {
                const { class: cls, label } = row.original.status;
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${cls}`} />
                        {label}
                    </div>
                );
            },
        },
	];

    const inviteUser = (e) => {
        setModalCentered(false);
        setOnContinue(() => () => continueInviteUser());

        if(!selectedSport) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Lo sport deve essere valorizzato per continuare");
            setModalShowed(true);
            return;
        }

        if(!selectedMembers || selectedMembers.length === 0) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Seleziona almeno uno Staff Tecnico per continuare");
            setModalShowed(true);
            return;
        }

        let notAllowed = [];
        if(memberOptionsFull && memberOptionsFull.items) {
            selectedMembers.forEach(id => {
                const item = memberOptionsFull.items.find(el => el.userId === id);
                if(!item || !item.taughtSportTypes || !item.taughtSportTypes.includes(selectedSport)) {
                    notAllowed.push(id);
                }
            });
        }
        if(notAllowed.length > 0) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Lo sport selezionato non è incluso tra quelli che lo Staff Tecnico può insegnare.");
            setModalShowed(true);
            return;
        }

        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? <b>Un invito sarà inviato agli utenti selezionati.</b>");
    };

    const continueInviteUser = () => {

		setConfirmShowed(false);

        const inviteUs = async () => {
            try {
				
				const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
					
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
					const clubId = tokenDetails.localId;
                    const apiClient = new MyApiClient();

                    const getNameById = (id) => {
                        if(memberOptionsFull && memberOptionsFull.items) {
                            const f = memberOptionsFull.items.find(el => el.userId === id);
                            return f ? f.name : id;
                        }
                        return id;
                    };

                    setModalCentered(false);
                    setLoadingShowed(true);
                    let ok = [];
                    let ko = [];
                    for (const uid of selectedMembers) {
                        let data_update = {
                            'userInvitations': [
                                {
                                    'userId': uid,
                                    'membershipRank': 'COACH',
                                    'sport': selectedSport
                                }
                            ]
                        };
                        const res = await apiClient.inviteUser(token, clubId, data_update);
                        if (res && res.error) {
                            const errMsg = (typeof res.error === 'string' ? res.error : '').toLowerCase();
                            let reason = "Errore: " + (typeof res.error === 'string' ? res.error : JSON.stringify(res.error));
                            if (errMsg.includes('membership already exists')) {
                                reason = 'Utente già maestro oppure richiesta già in corso per questo maestro';
                            }
                            ko.push({ id: uid, reason });
                        } else {
                            ok.push(uid);
                        }
                    }
                    setLoadingShowed(false);

                    const okNames = ok.map(getNameById);
                    const koNames = ko.map(k => `${getNameById(k.id)} (${k.reason})`);
                    setModalTitle('Esito inviti');
                    const parts = [];
                    if (okNames.length) parts.push(`Inviti riusciti: ${okNames.join(', ')}`);
                    if (koNames.length) parts.push(`Inviti non riusciti: ${koNames.join(', ')}`);
                    setModalText(parts.join('<br/>'));
                    setModalShowed(true);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        inviteUs();
    };

	useEffect(() => {
		const fetchData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString && profile) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					let token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const membershipData = getConfirmedMembers('COACH');
					const membershipDataPending = getPendingRequests('COACH');
					const [membershipDataUsers] = await Promise.all([
						apiClient.getProfilesByFilters(token,10000,null,'IDS_GURU')
					]);
					setLoadingShowed(false);

					if(membershipDataPending && membershipDataPending.length > 0) {
						membershipDataPending.forEach(element => {
							membershipData.push(element);
						})
					}

					if(membershipData && membershipData.length > 0) {
						let groupedMembers = {};
						membershipData.forEach(element => {
							if(element.status !== 'CONFIRMED') return;

							let sport_label = '';
							let sport_value = element.sport;
							sports.forEach(element2 => {
								if(element2.value === element.sport) {
									sport_label = element2.label;
								}
							});

							let image = null;
							if(element.picture && element.picture.uri) {
								image = element.picture.uri;
							}

							if(!groupedMembers[element.userId]) {
								groupedMembers[element.userId] = {
									id: element.userId,
									name: element.name,
									sportLabels: sport_label ? [sport_label] : [],
									sportValues: sport_value ? [sport_value] : [],
									status: {
										label: "Confermato",
										class: "text-success"
									},
									imageUrl: image,
									email: element.email
								};
							} else {
								if(sport_label && !groupedMembers[element.userId].sportLabels.includes(sport_label)) {
									groupedMembers[element.userId].sportLabels.push(sport_label);
								}
								if(sport_value && !groupedMembers[element.userId].sportValues.includes(sport_value)) {
									groupedMembers[element.userId].sportValues.push(sport_value);
								}
								if(!groupedMembers[element.userId].imageUrl && image) {
									groupedMembers[element.userId].imageUrl = image;
								}
							}
						});
						
						let data_member = Object.values(groupedMembers).map(m => ({
							id: m.id,
							name: m.name,
							sport: m.sportLabels.join(', '),
							sportValues: m.sportValues,
							status: m.status,
							imageUrl: m.imageUrl,
							email: m.email
						}));
						
						setDataJson(data_member);
					} else {
						// Dopo una cancellazione l'elenco puo' restare vuoto: niente righe vecchie
						setDataJson((prev) => (prev ? [] : prev));
					}

					if(membershipDataUsers && membershipDataUsers.items) {
						let data_member = [];
						membershipDataUsers.items.forEach(element => {
							
							let member_taught_sports = ' (';
							if(element.taughtSportTypes) {
								element.taughtSportTypes.forEach(element => {
									sports.forEach(element2 => {
										if(element === element2.value) {
											member_taught_sports += element2.label+', ';
										}
									});
								});
							}
							if(member_taught_sports === ' (') {
								member_taught_sports = '';
							} else {
								member_taught_sports = member_taught_sports.substring(0,member_taught_sports.length-2)+')';
							}

							let member_row = {
								"value": element.userId,
								"label": element.name+member_taught_sports
							};
							data_member.push(member_row);
					});

					setMemberOptions(data_member);
					setMemberOptionsFull(membershipDataUsers);
				}

					let new_sports = [];
					if(profile && profile.club && profile.club.sports) {
						profile.club.sports.forEach(element => {
							sports.forEach(element2 => {
								if(element2.value === element.sportType) {
									new_sports.push(element2);
								}
							});
						});
					}
					setShowedSports(new_sports);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		if (profile) {
			fetchData();
		}

	}, [getConfirmedMembers, getPendingRequests, profile]);

	function openDetail(row) {
		navigate('/struttura/maestri/maestro_profile/'+row.id);
	}

	// Dopo gli inviti: form pulito e dati ricaricati (anche il badge delle richieste)
	const ricaricaDopoInviti = () => {
		setSelectedMembers([]);
		setSelectedSport('');
		invalidateCache();
		fetchMemberships();
	};

	const availableMemberOptions = selectedSport && memberOptionsFull && memberOptionsFull.items
		? memberOptionsFull.items
			.filter(el => el.taughtSportTypes && el.taughtSportTypes.includes(selectedSport))
			.map(el => ({ value: el.userId, label: el.name }))
		: [];

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={confirmShowed} centered>
				<Modal.Header>
					<Modal.Title>Sei sicuro?</Modal.Title>
					<Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64" dangerouslySetInnerHTML={{ __html: confirmText }}></Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
						Chiudi
					</Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
						Continua
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => { setModalShowed(false); if (modalTitle === 'Esito inviti') { ricaricaDopoInviti(); } }} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64" dangerouslySetInnerHTML={{ __html: modalText }}></Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => { setModalShowed(false); if (modalTitle === 'Esito inviti') { ricaricaDopoInviti(); } }}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<TabellaLista
				pageList={true}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Maestri'}
				hasSearch={true}
				searchPlaceholder={'Cerca per nome o email'}
				hasFilter={false}
				filterControl={
					sportOptions.length > 1 && (
						<div className="sid-chip-filters">
							<ChipFilter label="Sport" options={sportOptions} value={sportFilter} onChange={setSportFilter} asDropdown />
						</div>
					)
				}
				data_column={data_column}
				data_json={filteredData}
				hasAddMoreAsModal={true}
				modalCallBack={() => setModalCentered(true)}
				modalContent={
					<Modal className="fade" show={modalCentered} centered>
						<Modal.Header>
							<Modal.Title>Invita uno Staff Tecnico nella tua struttura</Modal.Title>
							<Button onClick={() => setModalCentered(false)} variant="" className="btn-close" >
							</Button>
						</Modal.Header>
						<Modal.Body>
							<Form>
								<Row>
									<Col className="col-lg-12 pb-4">
						<Form.Label>Sport della tua struttura</Form.Label>
						<Select placeholder="Seleziona lo sport..." 
							value={showedSports?showedSports.filter(option => selectedSport === option.value):''}
							options={showedSports?showedSports:[]} onChange={handleSelectChangeSport}
							style={{lineHeight: "40px",color: "#fd7e14",paddingLeft: " 15px"}}
						/>
						<br></br>
						<Form.Label>Seleziona Staff Tecnico</Form.Label>
				    	<Select placeholder="Seleziona uno o più Staff Tecnico..." 
							value={availableMemberOptions.filter(option => selectedMembers.includes(option.value))}
							options={availableMemberOptions} onChange={handleSelectChangeMembers}
							isMulti
							isDisabled={!selectedSport}
							style={{lineHeight: "40px",color: "#fd7e14",paddingLeft: " 15px"}}
						/>
									</Col>
								</Row>
							</Form>
						</Modal.Body>
						<Modal.Footer className="justify-content-between">
							<Button className="btn btn-light btn-add" onClick={() => setModalCentered(false)}>
								Annulla
							</Button>
							<Button onClick={inviteUser} className="btn btn-primary btn-add">Invia invito</Button>
						</Modal.Footer>
					</Modal>
				}
			/>
		</>
	)
}

export default MaestriTable;
